import { useQuery } from "@tanstack/react-query";
import { getTargetareSnapshotJob } from "@/api/endpoints/targetareDate";
import { queryKeys } from "@/lib/queryClient";

const areJobActiv = (joburi: { stare: string }[] | undefined) =>
  (joburi ?? []).some((j) => j.stare === "programat" || j.stare === "in_curs");

export function useGetTargetareSnapshotJob(id: number | null) {
  return useQuery({
    queryKey: queryKeys.targetare.snapshotJob(id ?? 0),
    queryFn: () => getTargetareSnapshotJob(id ?? 0),
    select: (response) => response.data,
    enabled: id !== null,
    refetchInterval: (query) =>
      areJobActiv(query.state.data?.data) ? 4000 : false,
    staleTime: 1000 * 10,
    retry: 1,
  });
}
